module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _vm._v("chapter 1")]), _vm._v(" "), _c('h1', {
    staticClass: "subchapter"
  }, [_vm._v("Cocktails and Wine")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("A great tapas place is centered around its bar. In Spain this means a place that serves sherry wine and plenty of beer, with the odd whiskey thrown in. We try very hard to educate our patrons on what authentic Spanish tapas and the tapas experience are, but we make no effort to insist that the clientele drink the way they do in Spain. Masochists we aren’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We approached our bar by offering drinks that we liked ourselves. We had twenty-five wines by the glass at the outset—today we have more than forty—and we spent a tremendous amount of time trying wines that nobody was selling in the United States, such as godellos, albariños, and reds from Navarra and Jumilla.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a lot of hard work, and by kissing a few frogs, we found great wines at bargain prices that we wanted to introduce to an unknowing public. We wanted customers to ask the bartenders and waiters, “I don’t know any of these wines. What do you recommend?” Today the majority of our customers don’t look for a familiar midpriced California cabernet but instead know their Ribera del Dueros from their Riojas in a way that was scarcely imaginable back in 1996.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/1-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/2-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We have learned a lot about Spanish wine since we opened and offer our insights and recommendations for your own parties and simple meals on pages 6 to 13. But beyond wine, our customers and your party guests like their drinks mixed. With Spain not providing much inspiration in the way of cocktails, we looked to South America: We took on mojitos and caipirinhas early, sometimes driving to New York to get cachaça when nobody in Connecticut carried it. Gradually we created a specialty drink list, a potent mix of the accumulated wisdom of transient bartenders and the enthusiastic reception of longtime customers. Those are what you will find in this chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Try serving one or two cocktails at your next party. Everyone will love the excitement they provide. It’s probably not a good idea to try to make more than two cocktails in one evening, as they are labor intensive and have to be made by the drink. On the other hand, a pitcher of ice-cold sangria is easy and always welcome to augment the cocktails at any party.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _vm._v("Caipirinha")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("½ lime, quartered")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 tablespoon sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 ounces Lebron or other cachaça")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons lemon-lime soda")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" In a small bowl, mix the lime and sugar and with the back of a spoon or a muddler, push on the lime pieces to crush them into the sugar, or to “muddle” them. Transfer to a cocktail shaker.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Fill the shaker with ice cubes, add the cachaça, and shake 5 to 7 times. Pour into a highball glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("3.")]), _vm._v(" Pour the soda into the shaker and swirl to pick up the remaining lime and sugar. Top off the cocktail with the soda and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Clementine Crush")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("¼ cup freshly squeezed orange juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 ounces Svedka Clementine vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons lemon-lime soda")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the juice and vodka into a shaker filled with ice. Shake 3 to 5 times. Pour into a highball glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Top off with the soda and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/4-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Red Sangria")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Makes about 3 quarts, serving 6 to 8")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("Three 750 ml bottles red wine, such as Rioja or California zinfandel")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("½ cup brandy")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("⅓ cup light rum")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("⅓ cup Licor 43 or Triple Sec")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("⅓ cup amaretto")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("⅓ cup tequila")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 cups freshly squeezed orange juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 cups lemon-lime soda")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("About 2 cups sliced fresh fruit (such as oranges, green apples, grapefruit, pears, or strawberries) for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" In a very large pitcher or bowl (you might need 2 pitchers), mix together the red wine, brandy, rum, Licor 43, amaretto, and tequila. Add the orange juice and soda and stir to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Pour into tall glasses filled with ice. Garnish with fresh fruit and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("White Sangria")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Makes about 2 quarts, serving 4 to 6")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("Two 750 ml bottles crisp white wine, such as albariño")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("⅓ cup peach schnapps")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("⅓ cup apricot brandy")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 cups lemon-lime soda")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("¼ cup peach puree, nectar, or juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("About 2 cups sliced fresh fruit (such as oranges, tart green apples, peaches, nectarines, or plums), for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" In a very large pitcher or bowl (you might need 2 pitchers), mix together the white wine, schnapps, and brandy. Add the soda and peach puree and stir to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Pour into tall glasses filled with ice. Garnish with fresh fruit and serve.")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("SPANISH WINE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Spanish cuisine makes its way into America’s mainstream, the Spanish wine world is emerging as one of the connoisseurs’ favorite new frontiers. Wine drinkers across America have reason to celebrate, as wines and sherries from Spain are a treat to explore and to pour with our food.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Much of the wine that arrives on our shores from Spain seems new, fresh, and unknown, but ironically Spain has been producing wines since the days of the Roman Empire. It wasn’t until about thirty years ago, however, that any of the vintages made more than a few ripples on the international scene. The exception are the famed sherry wines from southern Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Barcelona we know that many of our guests are seeking an exciting dining experience but may not know much about the food or wine of Spain. While it’s relatively simple for them to decide what they might like from our tapas menu, the wine list often perplexes the average wine drinker. Therefore, to meet the demands of our evergrowing customer base, we instituted staff wine training in 2006. Every week Gretchen Thomas teaches classes on the wine regions of the world, different varietals and their characteristics, and the right choices for our menu offerings. She even gives quizzes. Hard ones! The best students in these classes become the restaurant’s “wine steward,” with the responsibility of keeping their knowledge current. So now, our waiters know even more about Spanish wines and how to pair them with our food.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Home cooks and party hosts may also want to pair Spanish wines with Spanish food for a full experience. Many of us think only of sangria when we consider Spanish wines, or perhaps we wonder about serving sherry. These are wonderful choices, but there is far, far more to Iberian wines. The next time you plan a party or casual get-together, try Spanish wines using the guidelines that follow. You won’t be disappointed.")]), _vm._v(" "), _c('h4', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("pairing wine with food")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Barcelona, our customers choose several different cold and hot tapas to combine and share as a meal with friends and family. It’s tricky to choose one wine to pair with several different meats, vegetables, fish, and sauces, which is why we have a wine director. Gretchen oversees five wine stewards, one at each restaurant. She works with the stewards so that everyone is up on all the wines and menu items and can help our customers have the best eating and drinking experience possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here Gretchen describes the four categories of Spanish wine, starting with sherry, going to white wine, cava (sparkling wine), and red wine. These characterizations will help ease the pain of decision making.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging002"
  }, [_c('strong', [_vm._v("1. SHERRY:")]), _vm._v(" Sherry is the oft-overlooked fortified wine from southern Spain that actually is one of the ideal beverages to pair with Spanish food. In the United States, many of us are familiar only with the sweet cream sherries, if we know sherry at all. In Spain it is customary to drink the drier-style sherries with savory food. Here are several styles of dry sherry and their best pairings:")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Fino is the lightest and driest of the sherry styles. It is pale, straw yellow, with distinct tangy, nutty aromas. Fino sherry pairs beautifully with olives, boquerones (anchovies), almonds, and Serrano ham. As a rule of thumb, fino can stand next to anything that is either briny or salty when other wines cannot.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Manzanilla is the same overall style and product as fino, but Manzanilla is made only in Sanlúcar de Barrameda. Fino is produced anywhere in the province of Jerez. Pair them with the same foods.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Amontillado sherries have more body, alcohol, and color than finos and Manzanilla. They have undergone some oxidation, which gives them their beautiful amber color and hazelnut aroma. They can be reminiscent of a fine whiskey, without the high alcohol content. This style of sherry pairs well with fresh chorizo, Manchego cheese, and dried fruits, especially figs. We especially love amontillado with our sausage-stuffed piquillo peppers.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Oloroso is the least dry of these sherries and has a mahogany color, as well as a rich walnut aroma and silky texture. These sherries are fantastic with braised or grilled red meats and are dynamite with a fine cigar.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging002"
  }, [_c('strong', [_vm._v("2. WHITE WINE:")]), _vm._v(" When your meal is laced with garlic, onions, vinegar, and spice, think white. Many of the tapas on our menu have strong flavors, such as Gambas al Ajillo, Grilled Steak Paillard, Mussels al Diablo, and Grilled Octopus Salad. Regardless of whether the main ingredient is fish or meat, the main flavor is what accompanies the protein and can often be harsh next to a heavy or oaky red wine. Clean and crisp white wines such as a godello or Txakolina will have the right amount of acidity to cut through any garlic or spice, plus the right body to enhance the food rather than overpower it.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging002"
  }, [_c('strong', [_vm._v("3. CAVA:")]), _vm._v(" When in doubt, choose cava, the sparkling wine of Spain made in the traditional method. It is often referred to as the “poor man’s Champagne,” but we like to think of it as “the smart man’s Champagne.” Made from native varietals, cava can be just as acidic, fleshy, and yeasty as many top Champagnes, but typically always at a much lower cost. The reasonable cost is due to several factors, including a much steadier grape-growing climate (Champagne, France, is one of the coldest wine-producing regions in the world). Cava also has less of a reputation as a luxury good. Because of the carbonation, sparkling wines are the most overall food-friendly wines on the planet. Those tiny bubbles cut through the fattiest piece of steak as well as complement any delicate fish. So, when pairing with a large array of tapas or food styles, cava is a hands-down winner.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging002"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('strong', [_vm._v("4. RED WINE:")]), _vm._v(" As for the red wines of Spain, follow this easy rule: If anything in the dish is smoked or the dish contains smoked paprika (such as Spanish chorizo), stick with the unoaked or lightly oaked red wines. Smoke in the food and smoke in the wine is, simply put, too much smoke. However, if planning on grilling or braising beef or lamb, the rich and oak barrel-aged red wines of Spain, especially of the tempranillo variety, are excellent companions for those rich red meats.")]), _vm._v(" "), _c('h4', {
    staticClass: "section"
  }, [_vm._v("developing an appreciation for spanish wine")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we opened our doors in 1996, our customers were still enchanted with California wine, for both its style and its value. Back then these wines were most of what was available, and we worked hard to assemble a humble selection of forty wines from Spain. Now, with the rapidly rising cost of California wines, along with our customers’ interest in new flavors and wine styles, our wine list has shrunk when it comes to the number of listings, but we now offer 120 Spanish wines spread over many appellations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our approach is simple: you tell us what you normally appreciate in a wine, and we will guide you to a vintage from Spain with the same profile. The majority of our customers are California-wine drinkers, and so they often associate the kinds of wines they prefer with specific varietals such as cabernet sauvignon, chardonnay, merlot, and pinot noir. Much to the surprise of many, more than these four varietals are planted in the world. In fact, there are thousands. Spain is an Old World wine region (as are all regions that belong to the European Union) and defines its wine types and styles based on the district where the grapes are grown and the wine is produced, as opposed to simply by the varietal. This bewilders the American consumer. It’s not unusual for an avid lover of Napa Valley cabernet sauvignons to be disappointed with a cab from Penèdes, Spain. But that is why we are here to help.")]), _vm._v(" "), _c('h4', {
    staticClass: "section"
  }, [_vm._v("for the cabernet sauvignon drinker")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So what exactly are cabernet lovers looking for in a Spanish wine? They crave intensity, with three very important factors: oak, alcohol, and fruit, preferably all at high levels. Until about ten years ago, finding an equivalent from Spain was difficult, but now, with a new crop of young University of California-Davis trained winemakers rooting themselves in Europe, the internationalization of wine is becoming more and more of a reality. There are several emerging wine regions in Spain that are known for their intense red wines, the most important ones being Ribera del Duero, Toro, and Priorat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ribera del Duero is home of Vega Sicilia, a winery that pioneered the addition of cabernet sauvignon, merlot, and Malbec to the indigenous tempranillo variety (think Super Tuscan meets Spain). Vega Sicilia has become one of the most sought-after and expensive wines produced in Spain and has set the standard for what consumers worldwide expect from a Ribera red. While most wineries in the region stick to using 100 percent tempranillo-based wines, the wines are always intense, beautifully ripe, aged in either French or American oak barrels, and generally higher than 13 percent alcohol. We have a few wines that are favorites with our cabernet-drinking customers:")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Viña Solorca—The “Gran Solorca Reserva” is definitely one of the greatest values out of the entire region.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Hacienda Monasterio—Famed winemaker Peter Sissek has taken on the project of blending the legal French varietals (cabernet sauvignon, malbec, merlot) in the tempranillo-based wine. The result is very comparable to Vega Sicilia, but without as high a price.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Bodegas Aalto—Mariano Garcia was the winemaker of Vega Sicilia for nearly thirty years before leaving to start his own project. Aalto is an incredibly ripe and layered tempranillo wine that never disappoints the Napa Valley aficionados.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _vm._v("The tiny region of Toro, which lies west of Ribera along the Duero River valley, produces mostly red wines that are generally 100 percent tempranillo. Toro reds carry distinct, consistent mocha aromas and flavors, as compared to the many other tempranillo wines of northern Spain. Although a lesser-known region, Toro has a few of its own accolade-garnering wineries, most notably San Roman and Bodegas Numanthia-Termes. While the wines fetch some incredibly high prices, most of the powerful tempranillo wines represent some of Spain’s top-value reds. A few of the ones we recommend are:")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Juan Rojo—A rich and full-bodied tempranillo made by one of Spain’s many emerging female winemakers, Rosa Zarza.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Prima—Another project of Mariano Garcia, this wine delivers powerful ripeness and tannins at a strikingly low price point.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third region that would satisfy the palates of the cabernet sauvignon drinker is the tiny region of Priorat. Located in Catalunya, just inland and over the mountains from Barcelona, Priorat has earned cultlike status in the wine world owing to its unique terraced vineyards and black slate soil. The “terroir” of this region renders the area nearly useless for cultivating anything other than grapevines; many describe the landscape as resembling a moonscape.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A handful of French and Spanish winemakers decided to revive the area’s once dead wine-producing culture in the late 1980s and bought up all the native old-vine garnacha (known as grenache in the south of France and the rest of the world) and Cariñena. They planted vineyards with cabernet sauvignon, merlot, and syrah grapes. Most of the wineries produce only a few hundred cases of wine a year; the soil makes the vines difficult to cultivate, so they produce low yields. But the wines are unsurpassed in strength and age-ability. Typically, the sweet and licorice garnacha is blended with earthy and dry cabernet sauvignon, delivering powerful tannins and body. In fact, the wine can’t even be labeled Priorat "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("unless it reaches at least 14.5 percent alcohol. While never inexpensive, Priorat reds are unforgettably complex and make our customers just as fanatic as we are.")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“Marge,” Celler de l’Encastell—This wine has become a staff favorite in our Norwalk location. One of the less expensive examples from this region, the Marge packs beautiful ripe and spicy aromas in a full-bodied package.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“Solanes,” Cims de Porrera—One of the only producers that bases the wine with more Cariñena than garnacha, the wine has a dusty dryness, which appeals to our Rutherford-loving wine guests.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Clos Erasmus—This wine is made by one of the most prestigious winemakers in the region, Daphne Glorian. It was one of the first wines to catch the attention of wine critics worldwide. Barcelona Wine Bar receives only a tiny allocation of the 140 cases produced each year.")])])]), _vm._v(" "), _c('h4', {
    staticClass: "section"
  }, [_vm._v("for the pinot noir drinker")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While cabernet sauvignon drinkers often dominate our wine-drinking customers, there is another popular red varietal that represents the other end of the flavor and style spectrum: pinot noir. Originally famous for the light, complex, and earth-driven wines from Burgundy, France, pinot noir grapes are now planted all over the world (not always successfully) and deliver a spectrum of wine styles. While California’s Santa Barbara Valley produces the most ripe, intense, and spicy pinots on the West Coast, Oregon’s Willamette Valley creates a light and elegantly styled wine. Spain is not exactly a pinot noir-producing country, and so Rioja is the best-known red wine-producing area that makes lighter-bodied yet complex wines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rioja is located in northern Spain, with its northernmost area considered a part of the Basque Country. Tempranillo is also the king varietal in this region, but it yields very different results compared to neighboring regions. Garnacha, mazuela, and graciano are all classic, native varietals, and all contribute to the final outcomes, depending on how successful the vintage was for tempranillo. The real factor that gives Riojas their distinct flavor profile and lightness is the oak barrel and bottle aging. Traditionally, American oak has always been used for both fermentation and aging vessels, but many producers have switched to using French oak for a more modern approach. Riojas are classified by how long they age before market release and are titled accordingly:")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Crianza—This wine spends a minimum of one year in the barrel and one year in the bottle before release.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Reserva—This wine spends a minimum of one year in the barrel and two years in the bottle before release.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Gran Reserva—This wine spends a minimum of two years in the barrel and three years in the bottle before release.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What’s the point? For a consumer, the idea is that no wine will be sold until it’s ready to drink, as opposed to selling newly released classified Bordeaux that have to be stored for ten years at your own risk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the internationalization of wine spreads worldwide, regions like Rioja have become divided by those producers who continue to make wine in the classic style and those who take a more modern approach. The main difference is intensity. The classic wines, which still dominate the area’s production, are lighter-bodied, bright, earthy, and low in tannin. The modern wines are substantially more concentrated and oaky, not too far from the style of Ribera del Duero reds. While our list has a few examples of the modern Rioja style, the majority are very Old World and are excellent substitutes for pinot noir. The best examples are:")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("La Rioja Alta—While this is probably one of the most classic wineries in Rioja, it consistently holds back wines from release for many years longer than the required minimums. For instance, the current crianza vintage is 2000.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("El Coto de Imaz—This is one of the most recognizable Riojas in the United States. Coto de Imaz remains one of the best quality-for-value Riojas made in the classic style.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("C.V.N.E.—This is considered one of the giants of the Rioja producers. C.V.N.E. (pronounced coo-nay) has a few examples in both the classic and modern styles, all very impressive and age worthy.")])])]), _vm._v(" "), _c('h4', {
    staticClass: "section"
  }, [_vm._v("for pinot grigio and sauvignon blanc drinkers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our white-wine drinkers are often more difficult to please than the red-wine lovers due to the vast style difference between California and Spanish white wines. Spain, like all Old World wine region countries, manipulates the varietal expression of its white wines very little. This means brand-new oak barrels are rarely used and malolactic fermentation (an awful vocabulary word that means the process that gives wines their distinct buttery and creamy nature) is generally halted to protect the fresh acidity. This presents a few challenges for our servers and bartenders, because those who like California chardonnay don’t always like the Spanish selections. However, for the pinot grigio and sauvignon blanc lovers, Spanish whites can be fantastically satisfying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While red wine production definitely dominates the scene in Spain, one region creates some of the most beautiful white wines on the market and is very up-and-coming internationally. Galicia, located in the northwestern corner of Spain, produces the vast majority of white wines coming from the country, not only because its climate is the most suitable for white grapes but also because the local cuisine is dominated by fish and seafood. Galicia, which hugs the coast of the Atlantic, is also known as “green Spain” because its landscape and culture are much more akin to those of Ireland than to the rest of Spain—a far cry from what we Americans imagine as being typical.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While several indigenous grape varieties are grown in the wine regions of Galicia, albariño and godello are the two standouts. Albariño, thought to have some genetic ties to Riesling, produces a highly aromatic white wine that has boomed in popularity in recent years. It produces very floral and tropical fruit aromas, and the ones from the best vineyards have distinct minerality and age-ability. Rías Baixas, a tiny region just north of the "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("Portuguese border, is where most of Galicia’s albariños are produced. Oak barrels are rarely used for fermenting or aging these wines, as it is believed that oak will clash with the natural beauty of the varietal, and so the wines are aged in stainless-steel barrels. A few producers experiment with used oak barrels to add subtle toast and vanilla notes to the wine. Some recommendations are:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/12-1.jpg"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Pazo de Señoráns—This is definitely one of the top producers because of its old-vine albariño vineyards. The outstanding quality of the wine is worth the extra money.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Lagar de Cervera—Owned by the La Rioja Alta family, this winery consistently impresses year after year.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“Nora de Neve,” Viña Nora—This is one of the few oak barrel-fermented albariños. It successfully balances floral and apple notes with a touch of toasty oak and is great for our California chardonnay lovers.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Godello presents quite a different profile from albariño. It, too, is grown all over Galicia, but it seems to have found its rightful home in Valdeorras, a region nestled between two mountain ranges in eastern Galicia. Godello never has the same aromatic potency as albariño, but at its best it can have the structure of Grand Cru Chablis. It is, for the time being, much more affordable. Because of its strong acid content, godello always seems the drier option of the two varietals. Our two favorites are:")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“Montenovo,” Val de Sil—This is an inexpensive and refreshing white wine. It is fermented in stainless steel and is completely clean and crisp.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“As Sortes,” Rafael Palacios—This has become something of a cult wine and is another rare example of a white that is fermented in oak barrels. It is more like a Meursault from Burgundy, and the smoky aromas always please our California wine drinkers.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Overall, Spain offers a broad range of wine styles. We truly believe there is a Spanish wine in the market, and on our wine list, for every type of wine drinker out there. From the light-bodied, quaffable table wines and extremely extracted red wines to age-worthy premier cru Bordeaux-like wines, they are all coming out of Iberia. And there are many more to be discovered. Between the wines by the glass and the ever-expanding wine list, we love to get the buzz going about the latest great wines from Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/14-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Effen Awesome")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("¼ cup pineapple juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 ounces black cherry vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce crème de cassis")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 maraschino cherry, for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the pineapple juice, vodka, and crème de cassis into a shaker filled with ice cubes. Shake 5 to 7 times and strain into a highball glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Garnish the cocktail with a cherry and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Comforter")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("½ cup unsweetened cranberry juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 ounces Stoli Razberi vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 tablespoon liquid sour mix")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Pour all the ingredients into a shaker filled with ice cubes. Shake 5 to 7 times, pour into a highball glass, and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("Mr. Pats’ Old-Fashioned Lemonade")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("½ lemon, quartered")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 tablespoon sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 ounces Ketel One Citroen vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce curaçao")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons lemon-lime soda")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" In a small bowl, mix the lemon and sugar. Using the back of a spoon or a muddler, push on the lemon pieces to crush them into the sugar, or “muddle” them. Transfer to a cocktail shaker.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Fill the shaker with ice cubes and add the vodka and curaçao. Shake 10 to 12 times and strain into a highball glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("3.")]), _vm._v(" Pour the soda into the shaker and swirl to pick up the remaining lemon and sugar. Top off the cocktail with soda and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/15-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/16-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("Blood Orange Margarita")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("6 tablespoons freshly squeezed blood orange juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce Cointreau")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons freshly squeezed lime juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("½ ounce Patron Silver tequila")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 tablespoon liquid sour mix")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("Margarita salt or other coarse salt, for salting the glass")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("Lime wedge")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the orange juice, Cointreau, lime juice, tequila, and sour mix into a shaker filled with ice cubes and shake 5 to 7 times.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Spread the salt on a plate. Rub the rim of a chilled highball glass with the lime wedge. Dip the rim of the glass in the salt to coat it.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("3.")]), _vm._v(" Pour the margarita into the glass and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/17-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v("Zaya Tai")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("2 ounces Zaya rum")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("¼ cup pineapple juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce crème de banana liqueur")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_vm._v("Pour all the ingredients into a shaker filled with ice cubes. Shake 5 to 7 times, pour into a highball glass, and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Matador")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("3 ounces 1800 Silver tequila or other tequila")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce blue curaçao")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("¼ cup unsweetened cranberry juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 tablespoon grenadine")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("Lemon-lime soda")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 lime wedge, for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the tequila, curaçao, cranberry juice, and grenadine into a shaker filled with ice cubes. Shake for 30 seconds and strain into a chilled martini glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Add a splash of soda, garnish the martini with the lime wedge, and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Gazpacho Boracho")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("Freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("6 tablespoons Barcelona Gazpacho (page 42) or other tomato-based gazpacho")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 ounces Tito’s Handmade Vodka or other high-quality vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("Dash of Tabasco sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 rib celery or 1 slice cucumber, for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Fill an 8-ounce highball glass with ice and sprinkle with pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Pour the gazpacho and vodka into a shaker filled with ice. Add the Tabasco and shake 10 or 12 times. Strain into the glass, garnish with celery or cucumber, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/19-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("Agave Martini")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("3 ounces Don Julio silver tequila or other tequila")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons curaçao")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("¼ cup unsweetened cranberry juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("½ ounce Cointreau")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("Freshly squeezed lime juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 orange wedge, for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the tequila, curaçao, cranberry juice, and Cointreau into a shaker filled with ice cubes. Shake 10 to 12 times and strain into a chilled martini glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Add a splash of lime juice, garnish the martini with the orange slice, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/20-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("Metrotini")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("2 ounces Svedka Clementine vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce Triple Sec")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons freshly squeezed blood orange juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 tablespoon freshly squeezed lime juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 thin slice blood orange, for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the vodka, Triple Sec, orange juice, and lime juice into a shaker filled with ice cubes. Shake 5 to 7 times and strain into a chilled martini glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Garnish with the blood orange slice and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/21-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("White Peach Martini")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("2 ounces Svedka Clementine vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce peach brandy")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce DeKuyper Peachtree schnapps")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons white peach puree (see Note)")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 thin slice fresh white peach")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the vodka, brandy, schnapps, and puree into a shaker filled with ice cubes. Shake 10 to 12 times and strain into a chilled martini glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Garnish the cocktail with a slice of white peach and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Peach puree is available at some liquor stores and specialty markets. If you can’t find it or would prefer to make your own, mash a very ripe, peeled white peach with a fork to make a puree.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/22-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _vm._v("Mojito")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("½ lime, quartered")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("5 fresh mint leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 tablespoon sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 ounces Bacardi Limón rum")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons club soda")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" In a small bowl, mix the lime, mint leaves, and sugar. Using the back of a spoon or a muddler, push on the lime pieces and mint leaves to crush them into the sugar, or “muddle” them. Transfer to a cocktail shaker.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Fill the shaker with ice cubes and add the rum. Shake 5 to 8 times and then pour into a highball glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("3.")]), _vm._v(" Pour the club soda into the shaker and swirl to pick up the remaining lime, mint, and sugar. Top off the cocktail with soda and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/23-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v("Martini Manzana Roja")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("2 ounces Zyr vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 ounces Golden Ger Green Apple Liqueur")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons liquid sour mix")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons unsweetened cranberry juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 thin slice red-skinned apple, for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the vodka, apple liqueur, sour mix, and cranberry juice into a shaker filled with ice cubes. Shake 8 to 10 times and strain into a chilled martini glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Garnish with the apple slice and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Pomegranate Martini")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Serves 1")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("2 ounces Grey Goose vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 ounce Triple Sec")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("2 tablespoons pomegranate juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("1 tablespoon freshly squeezed lime juice")])]), _vm._v(" "), _c('p', {
    staticClass: "extract01"
  }, [_c('strong', [_vm._v("5 pomegranate seeds, for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("1.")]), _vm._v(" Pour the vodka, Triple Sec, pomegranate juice, and lime juice into a shaker filled with ice cubes. Shake 10 to 12 times and strain into a chilled martini glass.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("2.")]), _vm._v(" Garnish the cocktail with the pomegranate seeds and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/25-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/26-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e221b680","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740790683_epub_c01_r1.vue
// module id = 84
// module chunks = 0